import { useEffect, useState } from "react";

const useSearch = (name, delay = 500) => {
  const [search, setSearch] = useState(name);

  useEffect(() => {
    const handler = setTimeout(() => {
      setSearch(name);
    }, delay);
    return () => clearTimeout(handler);
  }, [name, delay]);

  return search;
};

export default useSearch;
